document.addEventListener('click', function (e) {
    const target = e.target;
    if (target.closest('.js-accordion-button')){
        const parent = target.closest('.js-accordion')
        if (parent.classList.contains('active')) {
            parent.classList.remove('active')
            return
        }
        const allAccordion = document.querySelectorAll('.js-accordion.active');
        allAccordion.forEach(function (accordion) {
            accordion.classList.remove('active')
        })
        parent.classList.toggle('active')
    }
})
